/**
 * Licensed Materials - Property of IBM
 * (c) Copyright IBM Corporation 2015, 2021. All Rights Reserved.
 *
 * Note to U.S. Government Users Restricted Rights:
 * Use, duplication or disclosure restricted by GSA ADP Schedule
 * Contract with IBM Corp.
 */
"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var messages = require("../../../nls/setup/deploy/deploy.properties");
var ConfigHelper = /*#__PURE__*/function () {
  function ConfigHelper(scope) {
    _classCallCheck(this, ConfigHelper);
    this._scope = scope;
  }
  return _createClass(ConfigHelper, [{
    key: "isValidFieldSet",
    value: function isValidFieldSet(fieldSet) {
      var paramSet = {};
      if (this._scope.props.capability.mode) {
        fieldSet.items.forEach(function (item) {
          item.items.forEach(function (param) {
            if (_typeof(param) === "object") {
              if (param.key) {
                paramSet[param.key] = true;
              }
            } else {
              paramSet[param] = true;
            }
          });
        });
        for (var param in paramSet) {
          if (!this.isValidParam(param)) {
            return false;
          }
        }
      }
      return true;
    }
  }, {
    key: "isValidParam",
    value: function isValidParam(param) {
      var parameters = this._scope.props.capability.metadata.parameters || {},
        properties = parameters.properties,
        actions = parameters.actions;
      // check if defined
      if (properties && properties[param]) {
        if (actions) {
          // check if the param should be shown for the current action
          var errorState = this._scope.props.capability.serviceInstance && this._scope.props.capability.serviceInstance.status && this._scope.props.capability.serviceInstance.status.state === 'error';
          if (this._scope.props.capability.mode && this._scope.props.capability.mode === 'add' || errorState) {
            if (actions.create && actions.create.indexOf(param) === -1) {
              return false;
            }
          } else {
            if (actions.update && actions.update.indexOf(param) === -1) {
              return false;
            }
          }
        }
        return true;
      }
      return false;
    }

    // @returns value of the tooltip to show when this component is invalid, or the empty string
    // if we are valid.
  }, {
    key: "getTooltipValue",
    value: function getTooltipValue() {
      var props = this._scope.props;
      if (props.paramDef.validationMessage) {
        return props.paramDef.validationMessage;
      }
      // If schema is not satisfied, show a generic message
      // TODO improve with ajv
      var invalidFields = props.invalidFields || props.invalidProps;
      if (invalidFields && invalidFields[props.name]) {
        if (props.validationMessages && props.validationMessages[props.name]) {
          return props.validationMessages[props.name];
        }
        return messages.get("error.schema.validation");
      }
      return "";
    }
  }, {
    key: "isInvalid",
    value: function isInvalid() {
      var props = this._scope.props;
      var invalidFields = props.invalidFields || props.invalidProps;
      if (props.paramDef.validationMessage || invalidFields && invalidFields[props.name]) {
        return true;
      }
      return false;
    }
  }, {
    key: "arrayToSet",
    value: function arrayToSet(array) {
      if (!array) {
        return null;
      }
      var set = Object.create(null);
      array.forEach(function (value) {
        return set[value] = true;
      });
      return set;
    }
  }]);
}();
module.exports = ConfigHelper;